import styled from 'styled-components'

import BootstrapModalFooter from 'react-bootstrap/lib/ModalFooter'

export const ModalFooter = styled(BootstrapModalFooter)`
  padding: 40px;
  border: none;
  display: flex;
  justify-content: space-between;
`
